module.exports = __webpack_public_path__ + "img/1557614065349632002.3e72108e.png";